const Helpers = {
  share(url) {
    if (!url) {
      return;
    }
    window.open(url, "share", "width=600,height=313");
  },

  is_valid_email(email) {
    let pattern = new RegExp(
      /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i
    );
    return pattern.test(email);
  },

  validate(form, scroll = true, type = "form") {
    let errors = {};
    let formError = false;
    const fields = form.find(".required").not(".disabled");

    // Check if all required fields are filled
    for (let i = 0; i < fields.length; i++) {
      const input = $(fields[i]);
      let error = false;
      const name = input.attr("name");

      // Check field type
      switch (input.attr("type")) {
        // Email
        case "email":
          if (!input.val() || !Helpers.is_valid_email(input.val())) {
            error = true;
            errors[name] = translations.valid_email;
          }
          break;

        // Checkbox
        case "checkbox":
          if (!input.prop("checked")) {
            error = true;
            errors[name] = translations.required;
          }
          break;

        // radio
        case "radio":
          if (!$(`[name=${input.attr("name")}]:checked`).length) {
            error = true;
            errors[name] = translations.required;
          }
          break;

        // Text, textarea
        default:
          if (!input.val()) {
            error = true;
            errors[name] = translations.required;
          }
      }

      // Handle error class
      if (error) {
        let errorLabel = input.data("error-msg");
        if (!errorLabel) {
          errorLabel = errors[name];
        }

        formError = true;
        input.parent().addClass("error");
        input.siblings(".field__error").text(errorLabel);
      } else {
        input.parent().removeClass("error");
        input.siblings(".field__error").addClass("hidden");
      }
    }

    if (scroll && $(".errors-wrap").length) {
      // Scroll to error
      $("html,body").animate(
        {
          scrollTop: $(".errors-wrap").offset().top - 150,
        },
        1000
      );
    }

    return !formError;
  },
};

export default Helpers;
